export default class SelectionDetailController {

    constructor($scope, $state, $stateParams, ApiSelections, ApiTeam, $ionicLoading) {
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;

        this.ApiSelections = ApiSelections;
        this.ApiTeam = ApiTeam;

        this.includedCountries = '';
        this.isGroupAdmin = false;
        this.members = [];
        this.selection = {};
        this.selectionId = $stateParams.selectionId;

    }

    init() {
        let self = this;
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        this.ApiSelections.getSelection(this.selectionId).then((res) => {
            this.selection = res;
            if (this.selection) {
                if (this.selection.selection && this.selection.selection.investmentType)
                    this.selection.selection.investmentType = this.formatText(this.selection.selection.investmentType);
                if (this.selection.selection && this.selection.selection.country)
                    this.selection.selection.country = this.formatText(this.selection.selection.country);
                if (this.selection.selection && this.selection.selection.investmentProfessionalsTypes)
                    this.selection.selection.investmentProfessionalsTypes = this.formatText(this.selection.selection.investmentProfessionalsTypes);
            }

            return res;
        }).then((res) => {
            this.ApiTeam.getTeamMembers({active: true}).then((members) => {
                if (members != undefined) {
                    this.members = members;
                    this.includedCountries = this.retrieveIncludedCountries();
                    // assign member array to each license elemt in the selection array
                    if (members.length > 0 && this.selection.licenses) {
                        for (var i = this.selection.licenses.length - 1; i >= 0; i--) {
                            this.selection.licenses[i].users = members.map(function(m) {
                                return {
                                    userId: m.id,
                                    firstName: m.firstName,
                                    lastName: m.name,
                                    salutation: m.salutation,
                                    checked: self.checkIfUserIsLicensed(self.selection.licenses[i], m.id)
                                };
                            });
                        }
                    }
                }
                this.$ionicLoading.hide();
            });
        });

        this.ApiTeam.isGroupAdmin().then((res) => {
            if (typeof res != 'undefined') {
                this.isGroupAdmin = res;
            }
        });
    }

    retrieveIncludedCountries() {
      let self = this;
      var uniqueCountries = [];
      self.selection.childrenSelections
        .forEach((childSelection) => {
          var country = childSelection.country;
          if (!uniqueCountries.includes(country) && country) {
            uniqueCountries.push(country);
          }
        });

        return uniqueCountries.join(', ');
    }

    checkIfUserIsLicensed(license, userId) {
        return license.assignedUsers.some(function(elem) {
            return elem.id == userId;
        });
    }

    applyLicenses() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        let self = this;
        angular.forEach(self.selection.licenses, function(license, key) {
            let selectedMembers = license.users.filter(function(u) {
                    return u.checked === true;
                })
                .map(function(u) {
                    return u.userId;
                });

            self.ApiSelections.assignLicenses(selectedMembers, license.id).then((res) => {
                self.$state.go(self.$state.$current, null, { reload: true });
            });
        });
    }

    formatText(value){
        return value.replace(/;/g, ', ');
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selectionDetail.controller.js
 **/